module.exports = __webpack_public_path__ + "static/media/patient_education_big.f091613f.png";